import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

export const NoClaimsPlaceholder = ({isLoading, handleAddNewClick }) => {
    const trans = useTranslation().t("Sso");

    if (isLoading) {
        return <div className="empty-card">
            <div className="ui small active text loader1">
                {trans["Loading"]}
            </div>
        </div>;
    }
    return <div className="empty-card">
        <div className="empty-card-icon" aria-label="Users Icon">
            
            <Icon name="users" 
                width={40}
                height={40} 
            />
        </div>
        <div className="empty-card-text">
            <p>{trans["No_Claim_Defined"]}</p>
            <p>{trans["Please_Add_Claim"]}</p>
        </div>
        <button
            className="btn orange empty-add-btn"
            onClick={() => handleAddNewClick()}
        >
            Add New
        </button>
    </div>;
}
